import { Link } from "react-router-dom";
import { TALLY_URL, CONTACT_EMAIL } from "@/config/links";

export const Footer = () => (
  <footer data-testid="main-footer" className="border-t border-[#C8A97E]/25 bg-[#0B2215] py-16 md:py-20">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-serif-display text-3xl tracking-tight">
            <span className="font-semibold text-[#C8A97E]">OKAÏA</span> <span className="italic text-[#F9F8F6]">Dév</span>
          </p>
          <p className="mt-4 font-serif-display text-sm italic text-[#C8A97E]">
            Voir clair. Décider juste. Développer durablement.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="okaia-overline mb-6 text-[#A3B1AA]">Navigation</p>
          <ul className="space-y-3 text-sm font-light text-[#F9F8F6]/80">
            <li>
              <Link to="/clarifier-mon-besoin" data-testid="footer-diagnostic-link" className="transition-colors duration-300 hover:text-[#C8A97E]">
                Diagnostic Business — 49 €
              </Link>
            </li>
            <li>
              <a href={TALLY_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-tally-link" className="transition-colors duration-300 hover:text-[#C8A97E]">
                Questionnaire gratuit d'orientation formation
              </a>
            </li>
            <li>
              <Link to="/mentions-legales" data-testid="footer-mentions-link" className="transition-colors duration-300 hover:text-[#C8A97E]">
                Mentions légales
              </Link>
            </li>
            <li>
              <Link to="/confidentialite" data-testid="footer-confidentialite-link" className="transition-colors duration-300 hover:text-[#C8A97E]">
                Politique de confidentialité
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3 md:col-start-10">
          <p className="okaia-overline mb-6 text-[#A3B1AA]">Contact</p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-contact-email"
            className="text-sm font-light text-[#F9F8F6]/80 transition-colors duration-300 hover:text-[#C8A97E]"
          >
            {CONTACT_EMAIL}
          </a>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-3 border-t border-[#C8A97E]/15 pt-8 text-xs font-light text-[#A3B1AA]/70 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} OKAÏA Dév. Tous droits réservés.</p>
        <p className="italic">Marque indépendante d'orientation et d'accompagnement professionnel.</p>
      </div>
    </div>
  </footer>
);
